import { publicAssetsURL } from '#internal/nuxt/paths';export default publicAssetsURL("/images/404/img-404-haut-hd@1x.png")